module.exports = __webpack_public_path__ + "media/images/icon-trash-outline-7d34d7149783f2d70f0334824f1c5e3b.svg";